<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card style="position: relative">
      <div class="d-flex w-100">
        <form-input
          debounce="300"
          class="w-25"
          v-model="search"
          label="بحث"
          placeholder="ابدأ بالكتابة للبحث..."
        />
      </div>

      <b-row v-if="getIndexes.length > 0">
        <template v-if="getIndexes.length >= 10">
          <b-col cols="6">
            <b-list-group>
              <b-list-group-item
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'index-view',
                    params: { slug: item.slug },
                  })
                "
                v-for="item in getIndexes.slice(0, getIndexes.length / 2)"
                :key="item.slug"
                >{{ item.title }}</b-list-group-item
              >
            </b-list-group>
          </b-col>
          <b-col cols="6">
            <b-list-group>
              <b-list-group-item
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'index-view',
                    params: { slug: item.slug },
                  })
                "
                v-for="item in getIndexes.slice(getIndexes.length / 2 + 1)"
                :key="item.slug"
                >{{ item.title }}</b-list-group-item
              >
            </b-list-group>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="6">
            <b-list-group>
              <b-list-group-item
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'index-view',
                    params: { slug: item.slug },
                  })
                "
                v-for="item in getIndexes"
                :key="item.slug"
                >{{ item.title }}</b-list-group-item
              >
            </b-list-group>
          </b-col>
        </template>
      </b-row>
      <div v-else class="text-muted">لا توجد فهارس تطابق بحثك</div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BRow,
  BButton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import FormInput from "@/components/form-input/index.vue";
import indexes from "./indexes-data";
export default {
  components: {
    BCard,
    BCol,
    BRow,
    BButton,
    BListGroup,
    BListGroupItem,
    MinistryBreadcrumbs,
    FormInput,
  },
  data() {
    return {
      search: "",
      mainTitle: "الفهارس",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الفهارس",
          active: true,
        },
      ],
      indexes: indexes,
    };
  },
  computed: {
    getIndexes() {
      return this.indexes.filter((el) => el.title.includes(this.search));
    },
  },
};
</script>
